import HttpClient from '@/services/HttpClient';
import store from '@/store';
import { assignedOpenTasks, openTicketsForUser } from '@/modules/welcome/dashboardItems';
import PaymentPlanService from '@/modules/invoices/PaymentPlanService';

export default class DashboardService{
	httpClient;

	constructor() {
		this.httpClient = new HttpClient();
		this.paymentPlanService = new PaymentPlanService();
	}

	getActionItems() {
		let clientId = store.getters.getClientId;
		let features = store.getters.getFeatures || {};
		let user = store.state.loggedInUser || {};

		let assignedTasks = features.projectsEnabled ? this.getAssignedTasks(clientId, user.id) : Promise.resolve([]);
		let openTickets = features.ticketsEnabled ? this.getOpenTickets(clientId, user) : Promise.resolve([]);
		let paymentPlans = features.invoicesEnabled
			? this.paymentPlanService.getPaymentPlans().catch(() => ({ data: [] }))
			: Promise.resolve({ data: [] });

		return Promise.all([this.httpClient.get(`/${clientId}/actionItems`), assignedTasks, openTickets, paymentPlans])
			.then(([response, tasks, tickets, plans]) => {
				response.data.assignedTasks = tasks;
				response.data.openTickets = tickets;
				response.data.paymentPlans = plans.data || [];
				return response;
			})
			.catch((err) => Promise.reject(err));
	}

	getAssignedTasks(clientId, userId) {
		return this.httpClient.get(`/${clientId}/projectTypes`).then((response) =>
			Promise.all(
				response.data.map((projectType) =>
					this.httpClient.get(`/${clientId}/deliverables`, { params: { projectTypeId: projectType.id } })
				)
			).then((responses) => assignedOpenTasks(responses, userId))
		);
	}

	getOpenTickets(clientId, user) {
		return this.httpClient
			.get(`/${clientId}/tickets`, { params: { open: true } })
			.then((response) => openTicketsForUser(response.data, user.id, user.email));
	}
}
